<template>
    <div class="step">
        <div class="step__container">

            <!-- Title -->
            <div class="step__title" ref="title">
                <p>Let’s make a number for your account</p>
            </div>

            <!-- Subtitle -->
            <div class="step__subtitle" ref="subtitle">
                <p>We will use the area code provided below to create your Ohana number.</p>
            </div>

            <!-- Form -->
            <div class="step__form" ref="form">

                <!-- Number Part -->
                    <InputField
                        title="PHONE AREA CODE"
                        type="tel"
                        placeholder="415"
                        autocomplete="tel"
                        v-model="areaCode"
                        :disabled="false"
                        :errored="false"
                        :validated="areaCodeValid"
                        errorMessage=""
                        mask="###"
                    ></InputField>
            </div>

            <!-- Next Button -->
            <div class="step__button step__button--bottom" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button" :class="{ 'button--disable': !areaCodeValid }">
                    <span>Create Number</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

    import InputField from "@/components/1-common/InputField";
    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import { TimelineMax } from 'gsap';

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step6_MakeNum',
        data() {
            return {
                areaCode: ''
            }
        },
        watch: {
            areaCode: function (val) {
                
                const data = {
                    field: 'area_code',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            }
        },
        components: {
            InputField,
            checkWhiteIcon
        },
        computed: {
            areaCodeValid: function () {
                return this.areaCode.length == 3;
            }
        },
        methods: {

            goNextStep() {

                if (!this.areaCodeValid) {
                    return;
                }

                this.$emit('showLoading');
                
                const axios =  require('axios');
                const buyNumURL = "https://old.ohanaisfamily.com/api/buyNumber"

                const body = {
                    'areaCode': this.areaCode,
                    'uid': this.$parent.currentUid
                }

                axios.post(buyNumURL, body)
                .then(response => {
                    console.log('success num buy')
                    console.log(response);

                    this.$parent.ohanaNumber = response.data.phoneNumber;
                    this.$emit('dismissLoading');
                    this.$emit('nextStep');
                })
                .catch(error => {
                    console.log('error num buy')
                    console.log(error);
                    // this.$emit('dismissLoading');
                    // this.$emit('showError', error.message);
                })
            }
        },
        mounted() {
            
            amplitude.getInstance().logEvent('signup_page_makenum_loaded');

            const {title, subtitle, form, button} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(form, 1.2, {autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step6_MakeNum.vue?4e4aa51c